<template>
  <div>
    <p v-if="!hasBanId">
      ban id unknown
    </p>
    <player-ban-link
      v-if="hasBanId"
      :playerId="action.playerId"
      :banId="action.banId"
      lable="ban"
    />
  </div>
</template>

<script>
import PlayerBanLink from './PlayerBanLink.vue';

export default {
  name: 'UserActionInfoBanPlayer',

  components: {
    PlayerBanLink,
  },

  props: {
    action: {
      type: Object,
      required: true,
    }
  },

  computed: {
    hasBanId() {
      return 'banId' in this.action;
    },
  },
};
</script>
